module.exports = __webpack_public_path__ + "assets/img/logo.393e2eb1.png";